import { ChangeDetectionStrategy, Component } from '@angular/core';
import { progressFade } from '../../animations/progressfade.animation';
import { IPageBlockParameter } from '../../models/page.model';
import { HeroTeaserFacade } from '../../state/hero-teaser/hero-teaser.facade';
import { MagazineFacade } from '../../state/magazine/magazine.facade';
import { NewspaperFacade } from '../../state/newspaper/newspaper.facade';
import { PageTeaserFacade } from '../../state/page-teaser/page-teaser.facade';
import { PageFacade } from '../../state/page/page.facade';
import { PageComponent } from '../page.component';

@Component({
	selector: 'shop-page-start',
	templateUrl: './page-start.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	animations: [progressFade],
})
export class PageStartComponent extends PageComponent {
	public cta: IPageBlockParameter[] = [
		{
			name: 'text',
			value: 'Suche jetzt Deine Wunschzeitung in unserem Archiv aus:',
		},
		{
			name: 'caption',
			value: 'Zeitungen finden',
		},
		{
			name: 'link',
			value: '/suche',
		},
		{
			name: 'subText',
			value: '24-Stunden-Versand möglich!',
		},
	];

	constructor(public newspaperFacade: NewspaperFacade, public magazineFacade: MagazineFacade, public heroTeaserFacade: HeroTeaserFacade, public pageTeaserFacade: PageTeaserFacade, public pageFacade: PageFacade) {
		super();

		heroTeaserFacade.load();
		pageTeaserFacade.load();
	}

	public search(): void {
		this.newspaperFacade.load();
	}
}
